import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { loginSuccess, logout } from "../redux/auth/actions";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // Track route changes

  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        dispatch(logout()); // Ensure Redux state is cleared
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`${BASE_URL}/api/auth/user`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw new Error("User fetch failed");
        }

        const data = await res.json();
        dispatch(loginSuccess(data.user, token));
      } catch (err) {
        console.error("Authentication error:", err);
        dispatch(logout());
        sessionStorage.removeItem("token"); // Clear invalid token
      } finally {
        setLoading(false);
      }
    };

    // Fetch user only if token exists and user is not authenticated
    if (token && (!user || !isAuthenticated)) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [dispatch, token, user, isAuthenticated, location]); // Add location to re-run on route change

  // Log for debugging
  // console.log("ProtectedRoute - Token:", token, "isAuthenticated:", isAuthenticated, "Loading:", loading);

  // Immediate redirect if no token
  if (!token) {
    console.log("No token found, redirecting to /login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Show loading UI while fetching user data
  if (loading) {
    return <div>Loading...</div>; // Replace with a spinner if desired
  }

  // Redirect if not authenticated after loading
  if (!isAuthenticated) {
    console.log("Not authenticated, redirecting to /login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Render protected routes
  return <Outlet />;
};

export default ProtectedRoute;